import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { ModalController, IonInfiniteScroll, AlertController } from '@ionic/angular';
import { MissionsService } from 'src/app/services/missions.service';
import { ToolsService } from 'src/app/services/tools.service';
import { formatDate } from '@angular/common';
import { DomSanitizer } from '@angular/platform-browser';
import { FilterResumeResultsByDatePage } from '../filter-resume-results-by-date/filter-resume-results-by-date.page';

@Component({
  selector: 'app-modal-ia-results-resume',
  templateUrl: './modal-ia-results-resume.page.html',
  styleUrls: ['./modal-ia-results-resume.page.scss'],
})
export class ModalIaResultsResumePage implements OnInit {
  @Input() ia_template: any;
  @ViewChild(IonInfiniteScroll, { static: false }) infiniteScroll: IonInfiniteScroll;
  listActivities: any;
  listActivitiesFilter: any;
  listResultsFiltered: any;
  resumeResults: any;
  nextPage: any;
  optionsVisible = false;
  searchTerm: any;
  totalCount: any;
  statesCount: any;
  resultsFiltered: any;
  startDateFilter: any;
  endDateFilter: any;
  totalPointsCount: any;
  selectedMonth: any;
  searchText: any;
  results: any;
  filterByActivity: boolean = false;
  selectedActivityId: number | null = null;
  selectedActivityName: string | null = null;
  selectedRange: any;

  constructor(
    private modalController: ModalController,
    private missionService: MissionsService,
    private toolsService: ToolsService,
    private sanitizer: DomSanitizer,
    private alertController: AlertController,
  ) {}

  ngOnInit() {
    this.setDefaultMonth()
    this.returnIaResultsResume()
    this.getAllIaActivitiesByPlayer()
    const [year, month, monthName] = this.selectedMonth.split('-');
    this.selectedRange = monthName
  }

  async returnIaResultsResume() {
    this.toolsService.showLoader('Cargando...')
    try {
      const request: any = { template_id: this.ia_template.id };

      if (this.filterByActivity && this.selectedActivityId) {
        request.ia_activity_id = this.selectedActivityId;
      }

      const [year, month] = this.selectedMonth.split('-');
      request.month = month;
      request.year = year;
      const resume = await this.missionService.getIaResultsResume(request);
      this.resumeResults = resume
      this.nextPage = this.resumeResults.ia_results.next

      let listRewards = this.resumeResults.rewards
      this.resumeResults.ia_results.results = this.resumeResults.ia_results.results.map(result => {

        for(let reward of listRewards) {
          if (reward.ia_result === result.id) {
            result.total_points = reward.total_points
          }
        }

        result.created = formatDate(result.created, 'yyyy-MM-dd', 'en-US');

        if(typeof result.file === 'string' && result.file.toLowerCase().endsWith('.pdf')) {
          result.isPdf = true;
          result.file = this.sanitizer.bypassSecurityTrustResourceUrl(result.file);
        }
        return result
      });

      this.totalCount = this.resumeResults.ia_results.count
      this.statesCount = this.resumeResults.ia_results_count
      this.resultsFiltered = this.resumeResults.ia_results.results
      this.results = this.resultsFiltered
      this.totalPointsCount = this.resumeResults.total_points_count
      this.toolsService.dismissLoader()
    } catch (error) {
      console.error('Error: The summary could not be generated.', error)
    }
  }

  async getAllIaActivitiesByPlayer () {
    try {
      const ia_activities = await this.missionService.getAllIaActivitiesByPlayer(this.ia_template.id);
      this.listActivities = ia_activities
      this.listActivitiesFilter = ia_activities
    } catch (error) {
      console.error('Error: The ia_activities list could not be generated.')
    }
  }

  setDefaultMonth() {
    const currentDate = new Date();
    const year = currentDate.getFullYear();
    const month = (currentDate.getMonth() + 1).toString().padStart(2, '0');
    const monthNames = {
      1: "Enero",
      2: "Febrero",
      3: "Marzo",
      4: "Abril",
      5: "Mayo",
      6: "Junio",
      7: "Julio",
      8: "Agosto",
      9: "Septiembre",
      10: "Octubre",
      11: "Noviembre",
      12: "Diciembre"
    };
    this.selectedMonth = `${year}-${month}-${monthNames[month]}`;
  }

  returnState(result_state: any) {
    switch (result_state) {
      case "APPROVED":
        return {"name": "Aprobadas", "class": "approved-invoices"}
      case 'REJECTED':
        return {"name": "No Aprobadas", "class": "rejected-invoices"};
      case 'MANUAL_VALIDATION':
        return {"name": "Pendientes", "class": "pending-invoices"};
    }
  }

  // Muestra el menú de opciones cuando el buscador recibe el foco
  onSearchbarFocus() {
    this.optionsVisible = true;
  }

  onBlurChange() {
    setTimeout(() => {
      this.optionsVisible = false;
    }, 150);
  }

  // Se ejecuta cada vez que cambia el valor del ion-searchbar
  onSearchChange(event: any) {
    const term = event.target.value.toLowerCase() || '';

    if (term === '') {
      this.listActivities = [...this.listActivitiesFilter];
    } else {
      this.listActivities = this.listActivitiesFilter.filter(item =>
        item.name.toLowerCase().includes(term)
      );
    }
  }

  // Maneja la selección de un ítem
  async applyingFilters(item?: any | null) {
    this.toolsService.showLoader('Cargando...')
    const [year, month, monthName] = this.selectedMonth.split('-');
    let current_month = monthName
    const data: any = {
      template_id: this.ia_template.id,
    };
    try {
      if (item) {
        data.ia_activity_id = item.id
        this.filterByActivity = true;
        this.selectedActivityId = item.id;
        this.selectedActivityName = item.name;
      } else if (this.filterByActivity && this.selectedActivityId) {
        data.ia_activity_id = this.selectedActivityId;
      } 
      
      if (this.startDateFilter && this.endDateFilter && this.selectedRange === 'Personalizado') {
        let start_date = this.startDateFilter
        let end_date = this.endDateFilter
        start_date = new Date(formatDate(start_date, 'yyyy-MM-dd', 'en-US'));
        end_date = new Date(formatDate(end_date, 'yyyy-MM-dd', 'en-US'));
        start_date.setUTCHours(0, 0, 0, 0)
        end_date.setUTCHours(23, 59, 59, 999);
        start_date = start_date.toISOString();
        end_date = end_date.toISOString();

        data.start_date = start_date;
        data.end_date = end_date;
        data.year = null;
        data.month = null;
      } else if (this.selectedRange === 'Últimos Siete Días') {
        let today: any = new Date();
        let lastSevenDays: any = new Date();
        lastSevenDays.setDate(today.getDate() - 7);
        lastSevenDays = new Date(formatDate(lastSevenDays, 'yyyy-MM-dd', 'en-US'));
        today = new Date(formatDate(today, 'yyyy-MM-dd', 'en-US'));
        lastSevenDays.setUTCHours(0, 0, 0, 0)
        today.setUTCHours(23, 59, 59, 999);
        lastSevenDays = lastSevenDays.toISOString();
        today = today.toISOString();
        data.start_date = lastSevenDays;
        data.end_date = today;
      } else if (this.selectedRange === 'Mes Anterior') {
        const [year, month, monthName] = this.selectedMonth.split('-');
        data.year = year;
        data.month = month-1;
      } else if (this.selectedRange === current_month) {
        const [year, month, monthName] = this.selectedMonth.split('-');
        data.year = year;
        data.month = month;
      }

      if (this.searchTerm) {
        data.search_term = this.searchTerm
      }

      const response = await this.missionService.getIaResultsResume(data)
      this.resultsFiltered = response

      const listRewards = this.resultsFiltered.rewards

      this.nextPage = this.resultsFiltered.ia_results.next

      this.resultsFiltered.ia_results.results = this.resultsFiltered.ia_results.results.map(result => {
        for(let reward of listRewards) {
          if (reward.ia_result === result.id) {
            result.total_points = reward.total_points
          }
        }

        result.created = formatDate(result.created, 'yyyy-MM-dd', 'en-US');

        if(typeof result.file === 'string' && result.file.toLowerCase().endsWith('.pdf')) {
          result.isPdf = true;
          result.file = this.sanitizer.bypassSecurityTrustResourceUrl(result.file);
        }

        return result
      });

      this.totalCount = this.resultsFiltered.ia_results.count
      this.statesCount = this.resultsFiltered.ia_results_count
      this.results = this.resultsFiltered
      this.totalPointsCount = this.resultsFiltered.total_points_count
      this.resultsFiltered = this.resultsFiltered.ia_results.results
      this.toolsService.dismissLoader()
    } catch (error) {
      console.error('Error: The summary could not be generated.', error)
    }
    this.optionsVisible = false;
    if (this.listActivitiesFilter) {
      this.listActivities = [...this.listActivitiesFilter];
    }
  }

  clearActivityFilter() {
    this.filterByActivity = false;
    this.selectedActivityId = null;
    this.selectedActivityName = null;
    this.optionsVisible = false;
    if (this.listActivitiesFilter) {
      this.listActivities = [...this.listActivitiesFilter];
    }
    this.applyingFilters();
  }

  async showFailedRules(failed_rules: string) {
    let parsedFailedRules: any[] = [];
    let messageHTML = '';

    try {
      parsedFailedRules = JSON.parse(failed_rules.replace(/'/g, '"'));
    } catch (e) {
      console.error('Error al parsear failed_rules:', e);
      parsedFailedRules = [];
    }

    if (parsedFailedRules.length > 0) {
      const listItems = parsedFailedRules
        .map((rule) => `<li>${rule.message}</li>`)
        .join('');
      messageHTML = `<div class="alert-text"><ul>${listItems}</ul></div>`;
    } else {
      messageHTML = '<div class="alert-text">No hay reglas fallidas.</div>';
    }

    const alert = await this.alertController.create({
      header: 'Reglas Fallidas',
      message: messageHTML,
      buttons: ['OK'],
    });

    await alert.present();
  }

  async ionInfiniteScroll(event: any) {
    if (!this.nextPage) {
      event.target.disabled = true;
      event.target.complete();
      return;
    }

    try {
      const response = await this.missionService.getIaResultsResume({
        template_id: this.ia_template.id, 
        nextPage: this.nextPage
      });

      const res: any = response;
      const listRewards = res.rewards
            
      res.ia_results.results = res.ia_results.results.map(result => {

        for(let reward of listRewards) {
          if (reward.ia_result === result.id) {
            result.total_points = reward.total_points
          }
        }

        result.created = formatDate(result.created, 'yyyy-MM-dd', 'en-US');

        if (typeof result.file === 'string' && result.file.toLowerCase().endsWith('.pdf')) {
          result.isPdf = true;
          result.file = this.sanitizer.bypassSecurityTrustResourceUrl(result.file);
        }

        return result;
      });

      this.resultsFiltered.push(...res.ia_results.results);
      this.nextPage = res.ia_results.next;

      if (!this.nextPage) {
        event.target.disabled = true;
      }

    } catch (error) {
      console.error('Error al cargar más resultados:', error);
    } finally {
      event.target.complete();
    }
  }

  async openFilterByRange() {
    const [year, month, monthName] = this.selectedMonth.split('-');
    let month_name = monthName

    const modal = await this.modalController.create({
        component: FilterResumeResultsByDatePage,
        cssClass: 'ia-results-resume-modal-filters',
        componentProps: {
          selectedRange: this.selectedRange,
          currentMonth: month_name
        }
      });

      await modal.present();
      const { data, role } = await modal.onWillDismiss();

      if (role === 'confirm' && data) {
        this.selectedRange = data.selected_range;
        this.startDateFilter = data.start_date;
        this.endDateFilter = data.end_date
        this.applyingFilters();
      }
      
  }

  closeModal() {
    this.modalController.dismiss();
  }
}
